
<template>
  <div>
    <!--搜索区域-->
    <!-- <Form :label-width="100" inline>
      <FormItem label="设备SN号">
        <Input class="w-250" v-model="table.search.ClientSN"></Input>
      </FormItem>

    </Form> -->
    <!--操作区域-->
    <div class="mb-4 ml-5">
      <!-- <Button class="mr-3" type="primary" @click="search">查询</Button> -->
    </div>
    <!--列表区域-->
    <DataTable
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
      @selectionChange="selectionChange"
    ></DataTable>
    <div class="ml-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
    <!--详情-->
    <Modal
      v-model="detailModal"
      title="序列详情"
      :footer-hide="true"
      :closable="false"
    >
      <seriesinfodetail
        v-if="detailModal"
        @close="detailModal = false"
        :currentData="currentData"
      ></seriesinfodetail>
    </Modal>
    <!--ImageInfo-->
    <Modal
      v-model="ImageModal"
      title="关联影像"
      :footer-hide="true"
      :closable="false"
      :width="1200"
    >
      <imageinfolist
        v-if="ImageModal"
        @close="ImageModal = false"
        :StudyId="StudyId"
        :SeriesId="SeriesId"
      ></imageinfolist>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import seriesinfodetail from "../study/seriesdetail.vue";
import imageinfolist from "../study/imageinfolist.vue";

export default {
  props: ["StudyId"],
  components: { DataTable, seriesinfodetail, imageinfolist },
  data: function () {
    return {
      currentData: {},
      detailModal: false,
      ImageModal: false,  
      table: {
        columns: [
          {
            title: "序号",
            fixed: "left",
            type: "index",
            width: "60",
            align:'center'
          },

          { title: "最后更新时间",width: "140", key: "lastUpdateDate",align:'center' },
          { title: "机构编码", width: "88", key: "organCode",align:'center' },
          { title: "序列时间", width: "78", key: "seriesTime",align:'center' },
          { title: "序列日期", width: "85", key: "seriesDate",align:'center' },
          { title: "序列描述", width: "78", key: "seriesDescription",align:'center',tooltip: true },
          { width: "130", title: "序列ID", key: "seriesID", align:'center',tooltip: true},
          { width: "130", title: "SERIESUID", key: "seriesInstanceUID", align:'center',tooltip: true},
          { title: "序列类型", width: "78", key: "seriesModality",align:'center' },
          { title: "序列编号", width: "78", key: "seriesNumber",align:'center' },
          // { title: "字典类别代码", key: "studyID" },
          // { title: "字典类别名称", key: "studyInstanceUID" },
          {
            title: "操作",
            align:'center',
            width: "190px",
            fixed: "right",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toImage(params.row);
                      },
                    },
                  },
                  "关联图像"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      color:'#FA6266',
                    },
                    on: {
                      click: () => {
                        this.toDelete(params.row);
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
          },
        ],
        apiUrl: "StudyInfo/GetSeriesInfoList?StudyInfoId=" + this.StudyId,
        search: {},
      },
    };
  },
  beforeCreate: function () {
    //console.log("传参" + this.StudyId);
    // this.search.StudyId = this.StudyId;
  },
  mounted: function () {
    this.search()
  },

  methods: {
    search: function () {
      this.$refs.dataTable.initload();
    },

    toDetail: function (data) {
      this.detailModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
    },

    toAdd: function () {
      this.$router.push({ path: "departmentAdd" });
    },

    toEdit: function (data) {
      this.editModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
    },
    returnBack: function () {
      this.$emit("close");
    },
    toDelete:function (data) {
      this.$Modal.confirm({
        title: "确认要删除吗？",
        mask: false,
        onOk: () => {
          this.$api.get("StudyInfo/DeleteSeries?seriesID=" + data.seriesID).then((rsp) => {
            if (rsp != false) {
             this.$Message.success("删除成功");
             this.search()
            }
          });
        }
      })

      
     
    },
    toImage: function (data) {
      this.ImageModal = true;

      
      this.StudyId = data.studyID;
      this.SeriesId = data.seriesID;
      this.ImageId = data.ImageId;
    },
    //多选回调
    selectionChange(data) {
      this.selectionData = data;
    },
  },
};
</script>
<style scoped>
</style>